import { render } from "./DevelApllication.vue?vue&type=template&id=e3a9c9de&scoped=true"
import script from "./DevelApllication.vue?vue&type=script&lang=js"
export * from "./DevelApllication.vue?vue&type=script&lang=js"

import "./DevelApllication.vue?vue&type=style&index=0&id=e3a9c9de&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3a9c9de"]])

export default __exports__